/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC } from 'react'
import { shallowEqual } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useSelector } from '../../setup/redux/RootReducer'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { AuthPage } from '../modules/auth/AuthPage'
import { Logout } from '../modules/auth/Logout'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { PrivateRoutes } from './PrivateRoutes'
import { PublicRoutes } from './PublicRoutes'

const Routes: FC = () => {
  const isAuthorized = useSelector(({ auth }) => auth.user, shallowEqual)

  return (
    <Switch>
      {!isAuthorized ? (
        <Route>
          <PublicRoutes />
          {/* <AuthPage /> */}
        </Route>
      ) : (
        <Redirect from='/auth' to='/' />
      )}

      <Route path='/error' component={ErrorsPage} />
      <Route path='/logout' component={Logout} />

      {!isAuthorized ? (
        <Redirect to='/auth/login' />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
    </Switch>
  )
}

export { Routes }
